// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__v4Zn3","content":"Header_content__ivQIW","image":"Header_image__nmzG_"};